import { MaximumSubCategory } from 'app/models/maximumsubcategory';
export class MaximumCategory {
    public id: number;
    public category: String;
    public subCategory: String;
    public primaryAuthor: String;
    public secondaryAuthor: String;
    public accessType: String;
    public cmVmwProductId: number;
    public cmVmwProdRelId: number;
    public isSupport: boolean;
    public child: boolean;
    public prodManager: String;
    public qeMember: String;
    public perfMember: String;
    public devMember: String;
    public description: String;
    public lastUpdate: Date;
    public updatedBy: String;
    public clonecatId: number;
    public clonesubCatId: number;
    public cloneSourceCatid: number;
    public cloneTargetCatid: number;
    public subcategories: Array<MaximumSubCategory> = [];
    public  catSortorder: number;
    public  catSortType: number;
    public  catSelectedSortNumber: number;
    public  subCatSortorder: number;
    public  subCatSortType: number;
    public  subCatSelectedSortNumber: number;

}



// WEBPACK FOOTER //
// ./src/app/models/maximumcategory.ts